import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import styles from './TaskHeader.module.sass'

const TaskHeaderController = (props) => {
	const {
		task,
		requisition,
		hideAuthor = false,
		hideSpecialtyAndAppointment = false,
		showStatus = true,
		displayRequisition = false,
	} = props
	const { i18n, gotoAppointment, gotoRequisition } = useGlobal()

	console.log('requisition', requisition)
	console.log('hideSpecialtyAndAppointment', hideSpecialtyAndAppointment)
	console.log('displayRequisition', displayRequisition)
	console.log('data', props)

	const isRequisition = !!requisition

	return (
		<>
			{isRequisition ? (
				<VStack gap='xsmall' className={styles['header-root']}>
					<h2>{task?.title}</h2>
					<HStack gap='small' className={styles['task-status']}>
						{showStatus && (
							<strong>
								{i18n([requisition?.status?.description || ''])}
							</strong>
						)}

						{!hideAuthor &&
							(requisition?.trustCoordinatorMedic?.name ? (
								<small>
									(
									{i18n([
										requisition.trustCoordinatorMedic.name,
									])}
									)
								</small>
							) : null)}
					</HStack>
					<HStack>
						{!hideSpecialtyAndAppointment ? (
							<>
								<small>{i18n`Requested at ${requisition?.requisitionDate?.shortDateFormat}, on`}</small>
								<small
									className={styles['appointment']}
									onClick={() =>
										gotoAppointment(
											requisition?.processId,
											requisition?.appointment?.id
										)
									}
								>
									{`${requisition?.appointment?.medicalSpecialty?.name} #${requisition?.appointment?.id}`}
								</small>
							</>
						) : displayRequisition ? (
							<>
								<small>{i18n`Asked at ${requisition?.requisitionDate?.shortDateFormat}`}</small>
								<small
									className={styles['appointment']}
									onClick={() =>
										gotoRequisition(
											requisition?.processId,
											requisition?.id
										)
									}
								>
									{`${requisition?.type?.name} #${requisition?.id}`}
								</small>
							</>
						) : (
							<small>{i18n`Asked at ${requisition?.requisitionDate?.shortDateFormat}`}</small>
						)}
					</HStack>
				</VStack>
			) : (
				<VStack gap='xsmall' className={styles['header-root']}>
					<h2>{task?.title}</h2>
					{task?.createdAt !== 'Invalid date' && (
						<span>
							<small>{i18n`Asked at ${task?.createdAt}`}</small>
						</span>
					)}
				</VStack>
			)}
		</>
	)
}

export default TaskHeaderController
